import React, { useState } from "react";
import "./App.css";
import { Grid } from "@mui/material";
import NavBar from "./components/NavBar";
import Sidebar from "./components/Sidebar";
import FirstSection from "./components/FirstSection";
import AboutMeSection from "./components/AboutMeSection";
import SkillsSection from "./components/SkillsSection";
import ProjectsSection from "./components/ProjectsSection";
import ContactMeSection from "./components/ContactMeSection";
import Footer from "./components/Footer";

function App() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Grid container direction="column">
      <Grid item>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <NavBar toggle={toggle} />
        <FirstSection />
        <AboutMeSection />
        <SkillsSection />
        <ProjectsSection />
        <ContactMeSection />
        <Footer />
      </Grid>
    </Grid>
  );
}

export default App;
